import SummaryList from 'src/components/SummaryList';
import SummaryLine from 'src/components/SummaryLine';
import SummaryCard from 'src/components/SummaryCard';
import { Grid } from '@mui/material';
import { createLeasedAssetSummaryValues } from 'src/util/createReviewValues';
import { useEffect, useState } from 'react';

/**
 * Renders a summary of leased assets.
 *
 * @param {object} props - The props for the component.
 * @param {Array} props.assets - The array of assets to be summarized.
 */
const LeasedAssetSummary = ({ assets }) => {
  /**
   * The state for the array of leased assets.
   */
  const [leasedAssets, setLeasedAssets] = useState([]);

  /**
   * The state for the summary content to be displayed in the summary card.
   */
  const [leasedAssetSummaryContent, setLeasedAssetSummaryContent] = useState([]);

  /**
   * Use effect hook that sets the leased asset summary values in state when the assets prop changes.
   */
  useEffect(() => {
    const leasedAssetSummaryValues = createLeasedAssetSummaryValues(assets);
    setLeasedAssets(leasedAssetSummaryValues);
  }, [assets]);

  /**
   * Use effect hook that sets the summary content in state based on the leased asset summary values.
   * If the updated value is an array, a SummaryList component is rendered.
   * Otherwise, a SummaryLine component is rendered.
   */
  useEffect(() => {
    const summaryContent = leasedAssets.map(({ label, updated }, index) =>
      Array.isArray(updated) === true ? (
        <SummaryList label={label} values={updated} key={index} />
      ) : (
        <SummaryLine label={label} value={updated} key={index} />
      )
    );

    setLeasedAssetSummaryContent(summaryContent);
  }, [leasedAssets]);

  return (
    <Grid container spacing={2}>
      <SummaryCard title="Updated" summaryContent={leasedAssetSummaryContent} />
    </Grid>
  );
};

export default LeasedAssetSummary;
